module.exports = __webpack_public_path__ + "img/win.b32c2dc4.png";